class CustomCarousel extends HTMLElement {
	constructor() {
		super();
		this.splide = null;
	}

	connectedCallback() {
		const enableDesktopCarousel = this.getAttribute('enable-desktop-carousel') === 'true';
		const enableMobileCarousel = this.getAttribute('enable-mobile-carousel') === 'true';

		// Get grid settings from attributes
		const desktopColumns = parseInt(this.getAttribute('desktop-columns')) || 1;
		const mobileColumns = parseInt(this.getAttribute('mobile-columns')) || 1;
		const desktopGap = parseInt(this.getAttribute('desktop-gap')) || 0;
		const mobileGap = parseInt(this.getAttribute('mobile-gap')) || 0;

		// Add new attribute parsing
		const autoplay = this.getAttribute('autoplay') === 'true';
		const interval = parseInt(this.getAttribute('interval')) || 5000;
		const showArrows = this.getAttribute('show-arrows') !== 'false';
		const showDots = this.getAttribute('show-dots') !== 'false';
		const perMove = parseInt(this.getAttribute('per-move')) || 1;
		const infiniteLoop = this.getAttribute('infinite-loop') !== 'false';

		// Initialize Splide based on screen size and settings
		const isMobile = window.innerWidth < 750; // Match Shopify's breakpoint

		if ((isMobile && enableMobileCarousel) || (!isMobile && enableDesktopCarousel)) {
			this.initSplide({
				perPage: isMobile ? mobileColumns : desktopColumns,
				gap: `${isMobile ? mobileGap : desktopGap}px`,
				autoplay: autoplay,
				interval: interval,
				arrows: showArrows,
				pagination: showDots,
				perMove: perMove,
				type: infiniteLoop ? 'loop' : 'slide',
			});
		} else {
			// Remove Splide classes if carousel is not enabled for current device
			this.classList.remove('splide');
			const track = this.querySelector('.splide__track');
			const list = this.querySelector('.splide__list');

			if (track && list) {
				// Unwrap the track while preserving the list and its contents
				track.parentNode.insertBefore(list, track);
				track.parentNode.removeChild(track);

				// Remove Splide classes from list and slides
				list.classList.remove('splide__list');
				list.querySelectorAll('.splide__slide').forEach((slide) => {
					slide.classList.remove('splide__slide');
				});
			}
		}

		// Handle resize events to reinitialize when needed
		window.addEventListener('resize', this.handleResize.bind(this));
	}

	disconnectedCallback() {
		if (this.splide) {
			this.splide.destroy();
		}
		window.removeEventListener('resize', this.handleResize.bind(this));
	}

	handleResize() {
		const enableDesktopCarousel = this.getAttribute('enable-desktop-carousel') === 'true';
		const enableMobileCarousel = this.getAttribute('enable-mobile-carousel') === 'true';
		const isMobile = window.innerWidth < 750;

		// Determine if we need to reinitialize
		const shouldBeCarousel = (isMobile && enableMobileCarousel) || (!isMobile && enableDesktopCarousel);
		const isCurrentlyCarousel = this.splide !== null;

		if (shouldBeCarousel !== isCurrentlyCarousel) {
			// Reload the page to reinitialize
			window.location.reload();
		}
	}

	initSplide(deviceSpecificOptions = {}) {
		// Base options
		const options = {
			type: 'slide',
			arrows: true,
			pagination: true,
			autoplay: false,
			interval: 5000,
			speed: 400,
			perMove: 1,
			...deviceSpecificOptions,
		};

		// Initialize Splide
		this.classList.add('splide');
		this.splide = new Splide(this, options);
		this.splide.mount();
	}
}

// Register the custom element
customElements.define('custom-carousel', CustomCarousel);

// cart page block

if (location.pathname === '/cart' && !location.search) {
	window.location.href = '/?return_link=cart';
}

// Open cart drawer when redirected with ?return_link=cart
if (new URLSearchParams(location.search).has('return_link')) {
	const cartDrawerObserver = new MutationObserver(() => {
		let cartDrawer = document.querySelector('cart-drawer');
		if (cartDrawer) {
			cartDrawer.show();
			cartDrawerObserver.disconnect(); // Stop observing after cart opens
		}
	});
	cartDrawerObserver.observe(document.body, { childList: true, subtree: true });

	// Remove return_link=cart from the URL
	const newUrl = location.href.replace(/[?&]return_link=cart/g, '');
	history.replaceState({}, document.title, newUrl);
}

// Handle browser back button to close cart
window.addEventListener('popstate', function (event) {
	const cartDrawer = document.querySelector('cart-drawer');
	if (cartDrawer && !location.search.includes('cartOpen=true')) {
		cartDrawer.close();
	} else if (event.state?.cart === 'show' && cartDrawer) {
		cartDrawer.show();
	}
});

// Ensure cartOpen=true is removed from URL if cart is closed
document.addEventListener('DOMContentLoaded', () => {
	const cartDrawer = document.querySelector('cart-drawer');
	if (cartDrawer && !cartDrawer.classList.contains('active')) {
		const newUrl = location.href.replace(/[?&]cartOpen=true/g, '');
		history.replaceState({}, document.title, newUrl);
	}
});

// Open cart and push cartOpen=true into history
function openCart() {
	const cartDrawer = document.querySelector('cart-drawer');
	if (cartDrawer) {
		cartDrawer.show();
		history.pushState({ cart: 'show' }, '', '?cartOpen=true');
	}
}

// rating js

// judgeme js

const ratingProductCard = document.querySelector(".rating-pdp-card");
const judgemeProductReviews = document.getElementById(
  "judgeme_product_reviews"
);
ratingProductCard?.addEventListener("click", function () {
  judgemeProductReviews.scrollIntoView({ behavior: "smooth" });
});

class RoundRating extends HTMLElement {
  constructor() {
    super();
    this.#init();
  }

  #init() {
    const value = parseFloat(this.textContent.trim());
    const roundedValue = Math.round(value * 10) / 10;
    this.textContent = roundedValue.toFixed(1);
  }
}

customElements.define("round-rating", RoundRating);

// cart-change-handler.js
document.addEventListener("cart:change", async (event) => {
  const cartData = event.detail.cart;
  const baseEvent = event.detail.baseEvent;

  console.log("Cart Data:", cartData.items);
  console.log("Base Event:", baseEvent);

  // Handle changes to the main product quantity
  if (
    baseEvent === "line-item:change" ||
    baseEvent === "variant:add" ||
    baseEvent === "item:remove"
  ) {
    const mainProduct = cartData.items.find(
      (item) => !item.properties?._main_product
    );

    // Handle case where main product is removed or quantity is 0
    if (!mainProduct || mainProduct.quantity === 0) {
      // Find all items that have _main_product property
      const addOns = cartData.items.filter(
        (item) => item.properties?._main_product
      );

      if (addOns.length > 0) {
        document.documentElement.dispatchEvent(
          new CustomEvent("theme:loading:start", { bubbles: true })
        );

        try {
          let sectionsToBundle = [];
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:prepare-bundled-sections", {
              bubbles: true,
              detail: { sections: sectionsToBundle },
            })
          );

          // Prepare updates to set add-on quantities to 0
          const updates = addOns.reduce((acc, addon) => {
            acc[addon.key] = 0;
            return acc;
          }, {});

          const response = await fetch(
            `${window.Shopify.routes.root}cart/update.js`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
              },
              body: JSON.stringify({
                updates,
                sections: sectionsToBundle.join(","),
                sections_url: window.location.pathname,
              }),
            }
          );

          if (!response.ok) throw new Error("Failed to update cart");

          const updatedCartContent = await response.json();

          // Dispatch cart change event to update the UI
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:change", {
              bubbles: true,
              detail: {
                baseEvent: "item:remove",
                cart: updatedCartContent,
              },
            })
          );

          // Update cart UI
          const cart =
            document.querySelector("cart-notification") ||
            document.querySelector("cart-drawer");
          if (cart) {
            cart.renderContents(updatedCartContent);
          }
        } catch (error) {
          console.error("Error removing add-ons:", error);
          if (window.themeVariables?.settings.showErrorMessage) {
            alert(error.message);
          }
        } finally {
          document.documentElement.dispatchEvent(
            new CustomEvent("theme:loading:end", { bubbles: true })
          );
        }
      }
    } else if (mainProduct && mainProduct.quantity > 0) {
      // Sync add-on quantities with the main product quantity
      const addOns = cartData.items.filter(
        (item) => item.properties?._main_product === mainProduct.handle
      );

      if (addOns.length > 0) {
        document.documentElement.dispatchEvent(
          new CustomEvent("theme:loading:start", { bubbles: true })
        );

        try {
          let sectionsToBundle = [];
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:prepare-bundled-sections", {
              bubbles: true,
              detail: { sections: sectionsToBundle },
            })
          );

          // Prepare updates to sync add-on quantities with the main product
          const updates = addOns.reduce((acc, addon) => {
            acc[addon.key] = mainProduct.quantity;
            return acc;
          }, {});

          const response = await fetch(
            `${window.Shopify.routes.root}cart/update.js`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
              },
              body: JSON.stringify({
                updates,
                sections: sectionsToBundle.join(","),
                sections_url: window.location.pathname,
              }),
            }
          );

          if (!response.ok) throw new Error("Failed to update cart");

          const updatedCartContent = await response.json();

          // Dispatch cart change event to update the UI
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:change", {
              bubbles: true,
              detail: {
                baseEvent: "item:update",
                cart: updatedCartContent,
              },
            })
          );

          // Update cart UI
          const cart =
            document.querySelector("cart-notification") ||
            document.querySelector("cart-drawer");
          if (cart) {
            cart.renderContents(updatedCartContent);
          }
        } catch (error) {
          if (window.themeVariables?.settings.showErrorMessage) {
          }
        } finally {
          document.documentElement.dispatchEvent(
            new CustomEvent("theme:loading:end", { bubbles: true })
          );
        }
      }
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
	const video = document.querySelector('.video-element');
	const muteToggle = document.getElementById('mute-toggle');
	const unmuteText = muteToggle.querySelector('.unmute-text');
	const muteText = muteToggle.querySelector('.mute-text');

	if (video && muteToggle) {
		// Toggle mute/unmute when the button is clicked
		muteToggle.addEventListener('click', function () {
			video.muted = !video.muted;

			// Toggle button text
			if (video.muted) {
				unmuteText.style.display = 'inline';
				muteText.style.display = 'none';
			} else {
				unmuteText.style.display = 'none';
				muteText.style.display = 'inline';
			}
		});

		// Toggle play/pause on video click
		video.addEventListener('click', function () {
			this.paused ? this.play() : this.pause();
		});
	}
});

// Size Chart Toggle in inches and cms
window.handleSizeToggle = function () {
	const tabs = document.querySelectorAll('.toggle-tab-inches-cm');
	tabs.forEach(tab => {
		tab.addEventListener('click', function() {
			const tabId = this.dataset.tab;
			// Remove active class from all tabs
			tabs.forEach(t => t.classList.remove('active'));
			// Add active class to clicked tab
			this.classList.add('active');
			// Hide all tab contents
			document.querySelectorAll('.tab-content-inches-cm').forEach(content => {
				content.style.display = 'none';
			});
			// Show the selected tab content
			document.getElementById(tabId).style.display = 'block';
		});
	});
};

window.handleSizeToggle();

window.handleSizeChartTabs = function() {
	const tabButtons = document.querySelectorAll('.size-chart-container .tab-button');
	const tabPanes = document.querySelectorAll('.size-chart-container .tab-pane');
	
	tabButtons.forEach(button => {
		button.addEventListener('click', function() {
			// Remove active class from all buttons and panes
			tabButtons.forEach(btn => btn.classList.remove('active'));
			tabPanes.forEach(pane => pane.classList.remove('active'));
			
			// Add active class to clicked button
			this.classList.add('active');
			
			// Show corresponding tab pane
			const tabId = this.getAttribute('data-tab');
			document.getElementById(tabId).classList.add('active');
		});
	});
};

// Call the function after DOM is loaded
document.addEventListener('DOMContentLoaded', window.handleSizeChartTabs);